export default "__VITE_ASSET__BlJIXVZQ__"